import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const insuranceProviderSlice = createSlice({
  name: "pendingInsuranceProvider",
  initialState: false,
  reducers: {
    setFieldCompleted: (state, action: PayloadAction<boolean>) => {
     return action.payload
    },
  },
});

export const { setFieldCompleted } = insuranceProviderSlice.actions;
export default insuranceProviderSlice.reducer;
